import { render, staticRenderFns } from "./BYCItem.vue?vue&type=template&id=67d876f6&scoped=true&"
import script from "./BYCItem.vue?vue&type=script&lang=js&"
export * from "./BYCItem.vue?vue&type=script&lang=js&"
import style0 from "./BYCItem.vue?vue&type=style&index=0&id=67d876f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d876f6",
  null
  
)

export default component.exports